export default __webpack_public_path__ + "images/2G.c7eb987.png";